import { RootState } from "@store/reducers";
import { PencilLineIcon } from "lucide-react";
import { useState } from "react";
import { useSelector } from "react-redux";
import AddEditSkillModal from "../components/AddEditSkillModal";

interface Skill {
  _id: string;
  title: string;
}

const SkillSection = () => {
  const aspirationDetails = useSelector(
    (state: RootState) => state.auth.aspirationDetails,
  );

  const [isEditing, setIsEditing] = useState(false);

  return (
    <div className="flex flex-col border rounded-xl bg-white p-6 gap-4 relative">
      <div className="flex flex-col gap-1">
        <span className="uppercase text-xs font-bold text-slate-600">
          Skills{" "}
        </span>
        <span className="font-medium text-light-black text-xs">
          What skills would you like to be using?
        </span>
        <button
          onClick={() => setIsEditing(true)}
          className="hover:bg-gray-100 h-8 w-8 rounded-md flex items-center justify-center absolute right-3 top-3"
        >
          <PencilLineIcon className="h-5 w-5" />
        </button>
      </div>
      <div className="flex gap-3 flex-wrap">
        {aspirationDetails?.skills?.map((skill: Skill) => {
          return (
            <div
              key={skill._id}
              className="flex items-center justify-center rounded-full border font-medium text-xs px-4 py-1"
            >
              {skill?.title}
            </div>
          );
        })}
      </div>
      {/* Add/Edit Modal */}
      <AddEditSkillModal
        isEditing={isEditing}
        setIsEditing={setIsEditing}
        aspirationDetails={aspirationDetails}
      />
    </div>
  );
};

export default SkillSection;
